import { NavLink } from "react-router-dom";
import { LayoutDashboard, Building2, Package, ListChecks, UploadCloud, ShieldCheck, Users, LogOut, X, ClipboardList } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/lib/api";

export const LOGO = "https://images.squarespace-cdn.com/content/v1/60bf46855b35197d90ad4d6a/780c4acf-7864-4765-a17d-3edd1693e692/EP+Make+It+Easy+Animation+WHITE.gif";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, roles: ["manager", "purfleet_manager", "user"] },
  { to: "/accounts", label: "Accounts", icon: Building2, roles: ["manager", "purfleet_manager", "user"] },
  { to: "/products", label: "Products", icon: Package, roles: ["manager", "purfleet_manager", "user"] },
  { to: "/submissions", label: "My Submissions", icon: ClipboardList, roles: ["manager", "user"] },
  { to: "/tasks", label: "Purfleet Tasks", icon: ListChecks, roles: ["manager", "purfleet_manager"] },
  { to: "/uploads", label: "Uploads", icon: UploadCloud, roles: ["manager"] },
  { to: "/audit", label: "Audit Log", icon: ShieldCheck, roles: ["manager"] },
  { to: "/users", label: "Users", icon: Users, roles: ["manager"] },
];

export function Sidebar({ open, onClose, taskCount }) {
  const { user, logout } = useAuth();
  return (
    <aside className={`fixed inset-y-0 left-0 z-40 w-64 bg-[#0B132B] text-white flex flex-col transition-transform duration-200 ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`} data-testid="sidebar">
      <div className="px-6 pt-6 pb-5 border-b border-white/10">
        <button className="lg:hidden absolute right-3 top-3" onClick={onClose} data-testid="sidebar-close-btn"><X size={18} /></button>
        <img src={LOGO} alt="EP Group" className="w-40" />
        <p className="mt-4 font-display text-lg font-bold leading-tight">Targeted Account<br />Management</p>
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#D9232A] mt-1 font-semibold">TAM</p>
      </div>
      <nav className="flex-1 py-4 px-3 space-y-1">
        {NAV.filter((n) => n.roles.includes(user?.role)).map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={`nav-${label.toLowerCase().replace(/\s/g, "-")}`}
            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition-colors ${isActive ? "bg-[#D9232A] text-white font-semibold" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}>
            <Icon size={17} /> {label}
            {to === "/tasks" && taskCount > 0 && (
              <span className="ml-auto min-w-[22px] h-[22px] px-1.5 rounded-full bg-white text-[#D9232A] text-xs font-bold flex items-center justify-center" data-testid="nav-tasks-count">{taskCount}</span>
            )}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-white/10">
        <p className="text-sm font-semibold" data-testid="sidebar-user-name">{user?.name}</p>
        <p className="text-xs text-slate-400" data-testid="sidebar-user-role">{ROLE_LABEL[user?.role]}{user?.account_owner ? ` · ${user.account_owner}` : ""}</p>
        <button onClick={logout} className="mt-3 flex items-center gap-2 text-xs text-slate-300 hover:text-white transition-colors" data-testid="logout-btn">
          <LogOut size={14} /> Sign out
        </button>
      </div>
    </aside>
  );
}
